import React from "react";
import { FunctionField, ReferenceField } from "react-admin";
import { getProfessorRecordText } from "./_fieldsHelper";
import { employeeRequests } from "api/employeeApi";

const ProfessorField = ({ source, label = "Преподавател", filters = {} }) => {
  return (
    <ReferenceField
      source={source}
      reference={employeeRequests.getProfessorsSelect()}
      filter={filters}
    >
      <FunctionField
        render={getProfessorRecordText}
        label={label}
      />
    </ReferenceField>
  );
};

export default ProfessorField;
